import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import ContainerValidation from "../Components/ContainerValidation";
import HeaderValidation from "../Components/HeaderValidation";
import routes from "../../../../../Routes/routes";
import BodyValidation from "../Components/BodyValidation";
import React, {useEffect, useState} from "react";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {GetInvitationById} from "../../../../../reduxToolkit/Invitation/InvitationApi";
import {
    IconDocumentationValidation,
    IconIdentityApproved,
    IconIdNotFound,
    IconUnderReviewIdentity
} from "../../../../../components/buttons/IconButtons";
import {getUrlParameters} from "../Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const DocumentationUnderReview = () => {
    const navigate = useNavigate();
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const { id, guardFlowId} = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [Icon, setIcon] = useState(IconUnderReviewIdentity);
    const [data, setData] = useState();

    const invitationId = getInvitationById?.invitation?.id;

    /**
     * retrieves data from the invitation
     */
    useEffect(() => {
        if (id) {
            if(id !== invitationId){
                dispatch(GetInvitationById(id)).then(({payload:{data:{data,success}}})=>{
                    if (success) setData(data?.invitation?.statusId)
                });
            }else{
                setData(getInvitationById?.invitation?.statusId)
            }
        }
    }, [id, invitationId, dispatch]);

    useEffect(() => {
        if (data)
        switch (data) {
            case STATUS_MODEL.ACCEPTED:
                setTitle('documentation_validation_title_approved');
                setSubtitle('documentation_validation_subtitle_approved');
                setIcon(IconIdentityApproved);
                break;
            case STATUS_MODEL.REJECTED:
                setTitle('documentation_validation_title_rejected');
                setSubtitle('documentation_validation_subtitle_rejected');
                setIcon(IconIdNotFound);
                break;
            case STATUS_MODEL.PENDING_REVIEW:
                if(guardFlowId){
                    setTitle('visitor_information_is_currently_under_review');
                    setSubtitle('we_will_notify_you_once_the_review_is_complete');
                }else {
                    setTitle('your_information_is_currently_under_review');
                    setSubtitle('documentation_validation_subtitle_under_review');
                }
                setIcon(IconUnderReviewIdentity);
                break;
            default:
                setTitle('documentation_validation_title');
                setSubtitle('documentation_validation_subtitle');
                setIcon(IconDocumentationValidation)
                break;
        }
    }, [data])

    return (
        <ContainerValidation>
            <HeaderValidation url={getUrlParameters({url: routes.invitationDetails.registrationProcess, id, guardFlowId})}/>

            <BodyValidation showBtnPrev={true} showBtnNext={false}   clickPrev={() => {
                navigate(getUrlParameters({url: routes.invitationDetails.registrationProcess, id, guardFlowId}))
            }}>
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t(title)}</p>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t(subtitle)}</p>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center pt-3">
                        <div className="icon-identity-validation-container">
                            <Icon className="w-100 h-100" />
                        </div>
                    </div>

                </>
            </BodyValidation>
        </ContainerValidation>
    )

}
export default DocumentationUnderReview
